<h2>
  {{ title }}
  <span *ngIf="model.Id" title="CHI Payer Id">- {{ model.Id }}</span>
  <span *ngIf="model.Name">- {{ model.Name }}</span>
</h2>
<hr />

<div class="divrel">
  <tabset #tabs>
    <tab heading="General">
      <form (ngSubmit)="onSubmit()" #payerForm="ngForm" class="editForm" novalidate [ngBusy]="busy">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="control-label">Name</label>
              <input
                type="text"
                class="form-control"
                name="Name"
                [(ngModel)]="model.Name"
                #Name="ngModel"
                required
              />
              <app-tooltip [form]="'payer'" [uid]="'Name'"></app-tooltip>
            </div>
          </div>
        </div>

        <div class="row address">
          <div class="col-md-12">
            <app-address
              #physicalAddress
              [model]="model.PhysicalAddress"
              [title]="'Physical Address'"
              [usePayer]="true"
              [isRequired]="false"
            ></app-address>
          </div>
        </div>

        <div class="row address">
          <div class="col-md-12">
            <app-address
              #mailingAddress
              [model]="model.MailingAddress"
              [title]="'Mailing Address'"
              [usePayer]="true"
              [isRequired]="false"
              [linkedComponent]="physicalAddress"
            ></app-address>
          </div>
        </div>

        <hr />
        <div class="row">
          <button class="btn btn-default pull-right" type="button" (click)="backToList()">
            Back to list
          </button>
          <button type="submit" class="btn btn-success pull-right">Save</button>
        </div>
      </form>
    </tab>
    <tab heading="Contract & Support" [disabled]="!this.model.Id">
      <app-payer-contract-and-support> </app-payer-contract-and-support>
      <hr />
      <div class="row">
        <button class="btn btn-default pull-right" (click)="backToList()">Back to list</button>
      </div>
    </tab>
  </tabset>
</div>
